<div class="host-tujia-auto-receipt">
  <div class="body">
    <i
      nz-icon
      nzType="question-circle"
      nzTheme="outline"
      class="icon"></i>
    <span class="title">订单已接受，是否开启途家自动接单？</span>
    <div class="content">
      <p>开启后，途家渠道将自动接单，您可在渠道直连-渠道房源-途家 页面修改设置。</p>
      <label
        nz-checkbox
        [(ngModel)]="checked"
        class="checkbox">
        不再提醒
      </label>
    </div>
  </div>
  <div class="footer">
    <button
      nz-button
      (click)="onCancel()">
      取消
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="onConfirm()">
      确定
    </button>
  </div>
</div>
